<template lang="pug">
  .notice-fuli-container(v-if="isShow" v-platform-expose="moduleExpose" @click="handleClick" :class="computedStyle.containerClass")

    .notice-container
      img.notice-icon(:src="computedStyle.icon")
      Carousel.notice-carousel(
        scroll-direction="horizontal"
        :scroll-interval="3000"
        :speed="500"
        :data-list="notice"
        :seamless="false"
        v-if="needScroll"
      )
        template(slot-scope="{ itemData }")
          .notice-item(:class="computedStyle.textClass") {{ itemData }}

      .notice-carousel(
        v-else
      )
        .notice-item(:class="computedStyle.textClass" v-for="item in notice") {{ item }}

    img.notice-icon-go(:src="computedStyle.go" v-if="jumpUrl")
</template>

<script>
import { Carousel } from '@hb/platformui-h5';
import { WELFARE_VERSION } from "@/pages/welfare/consts";
import { env } from '@hb/NBridge/lib/h5';
import { jumpUrl as openPage } from '@/utils/tools';
import SPM from '../common/spm';

export default {
  name: "BountyNotice",
  components: {
    Carousel,
  },
  props: {
    styleVersion: {
      type: String,
      default: '',
    },
    // 新增：从父组件接收的公告数据，包含 noticeBoard 和 jumpUrl 字段
    noticeData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      notice: [],
      jumpUrl: '',
      needScroll: false,
    };
  },
  computed: {
    computedStyle() {
      const deepStyle = [
        WELFARE_VERSION.NEW_TASK_SCENE_V4,
        WELFARE_VERSION.NEW_TASK_SCENE_V3,
        WELFARE_VERSION.NEW_TASK_SCENE_V5,
      ];
      return deepStyle.indexOf(this.styleVersion) !== -1
        || env.isWechatMini
        || env.isAliMP
        || env.isAliMPMonitor ? {
          icon: "https://m.hellobike.com/3e6cc8f6_Vector.png",
          go: "https://m.hellobike.com/207ba40c_Frame.png",
          textClass: "new-welfare-text",
          containerClass: "new-welfare-bg",
        } : {
          icon: "https://m.hellobike.com/9dbaafd2_Vector%202.png",
          go: "https://m.hellobike.com/1a6746f9_Frame%20(1).png",
          textClass: "",
          containerClass: "",
        };
    },
    isShow() {
      return !!(this.notice && this.notice.length > 0);
    },
  },
  watch: {
    // 新增：监听 noticeData 变化，当有有效数据时覆盖组件内部数据
    noticeData: {
      handler(val) {
        const { noticeBoard, jumpUrl } = val || {};
        if (noticeBoard) {
          this.notice = [noticeBoard];
          this.jumpUrl = jumpUrl || '';
          this.needScroll = noticeBoard.length >= 24;
        }
        // 通知栏显隐变化时，更新 CSS 变量供 Lottie 动画定位
        this.$nextTick(() => this.updateNoticeHeight());
      },
      immediate: true,
      deep: true,
    },
  },
  beforeDestroy() {
    // 组件销毁时清理 CSS 变量，避免残留值影响 Lottie 定位
    document.documentElement.style.setProperty(
      '--welfare-notice-height',
      '0rem',
    );
  },
  methods: {
    moduleExpose() {
      SPM.moduleExpose({
        moduleId: "platform_noticeBoard",
        contentId: "platform_noticeBoard",
        exposureTimes: 1,
        businessInfo: {
          noticeData: this.noticeData,
        },
      });
    },
    handleClick() {
      const { jumpUrl } = this;
      if (jumpUrl) {
        openPage(this.jumpUrl);
        SPM.clickButton({
          buttonName: "platform_noticeBoard",
          businessInfo: {
            noticeData: this.noticeData,
          },
        });
      }
    },
    // 将通知栏外层容器的实际高度写入 CSS 变量
    updateNoticeHeight() {
      try {
        let h = 0;
        // 确保 DOM 已挂载、节点为元素节点（非注释节点）且父元素存在
        if (this.isShow && this.$el && this.$el.nodeType === 1 && this.$el.parentElement) {
          h = this.$el.parentElement.offsetHeight || 0;
        }
        document.documentElement.style.setProperty(
          '--welfare-notice-height',
          `${h / 100}rem`,
        );
      } catch (e) {
        // 容错：设置默认值，确保 Lottie 定位不受影响
        document.documentElement.style.setProperty(
          '--welfare-notice-height',
          '0rem',
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
.notice-fuli-container {
  width: 3.51rem;
  height: 0.3rem;
  margin: 0 auto;
  background-image: url('https://m.hellobike.com/990e91a1_Rectangle%20346243181%20(2)%20(1).png');
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  padding: 0.06rem 0.1rem 0.06rem 0.14rem;
  justify-content: space-between;

  &.new-welfare-bg {
    background-image: url('https://m.hellobike.com/6c71b1b8_Group%202130969260%20(1).png');
    border-color: transparent;
    background-color: unset;
  }

  .notice-icon {
    width: 0.12rem;
    height: 0.12rem;
    margin-right: 0.07rem;
  }

  .notice-icon-go {
    height: 0.1rem;
    width: 0.1rem;
  }

  .notice-container {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    margin-right: 0.07rem;

    .notice-carousel {
      display: flex;
      align-items: center;
      flex: 1;
      min-width: 0;
      height: 0.18rem;
      overflow: hidden;
    }
  }
}

.notice-item {
  white-space: nowrap;
  font-weight: 400;
  font-size: 0.12rem;
  color: #ffffff;
  height: 0.18rem;
  line-height: 0.18rem;
  margin-right: 0.4rem;

  &.new-welfare-text {
    color: #7F3200;
  }
}
</style>
